const locale = 'en-US';

const CHART_FLAT_DELTA = 0.005;

const formatCurrencyValue = (value) =>
    new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(Number.isFinite(value) ? value : 0);

export const formatMoney = (value) => `$${formatCurrencyValue(value)}`;

export const formatCount = (value) =>
    new Intl.NumberFormat(locale).format(Number.isFinite(value) ? value : 0);

export const sharePercent = (part, total) => {
    if (total <= 0) {
        return null;
    }
    return (part / total) * 100;
};

export const formatSharePercent = (pct) => {
    if (pct == null) {
        return null;
    }
    const rounded = Math.round(pct * 10) / 10;
    return Number.isInteger(rounded) ? `${rounded}%` : `${rounded.toFixed(1)}%`;
};

export const formatShareOrDash = (part, total) =>
    formatSharePercent(sharePercent(part, total)) ?? '—';

export const formatSignedCurrency = (value) => {
    const abs = formatCurrencyValue(Math.abs(value));
    if (value > 0) {
        return `+$${abs}`;
    }
    if (value < 0) {
        return `-$${abs}`;
    }
    return `$${abs}`;
};

export const formatSignedCount = (value) => {
    const abs = formatCount(Math.abs(value));
    if (value > 0) {
        return `+${abs}`;
    }
    if (value < 0) {
        return `-${abs}`;
    }
    return abs;
};

export const deltaTone = (delta) => {
    if (Math.abs(delta) < CHART_FLAT_DELTA) {
        return 'flat';
    }
    return delta > 0 ? 'up' : 'down';
};

const signedPercent = (delta) => {
    const abs = formatSharePercent(Math.abs(delta));
    if (abs == null) {
        return '—';
    }
    if (Math.abs(delta) < CHART_FLAT_DELTA) {
        return abs;
    }
    if (delta > 0) {
        return `+${abs}`;
    }
    return `-${abs}`;
};

export const kpiDelta = (compare, kind, current, previous) => {
    if (!compare) {
        return null;
    }
    if (current == null || previous == null) {
        if (kind === 'percent') {
            return { text: '—', tone: 'flat' };
        }
        return null;
    }
    const delta = current - previous;
    let text = formatSignedCount(delta);
    if (kind === 'money') {
        text = formatSignedCurrency(delta);
    } else if (kind === 'percent') {
        text = signedPercent(delta);
    }
    return { text, tone: deltaTone(delta) };
};

export const periodChangePercent = (current, previous) => {
    if (previous === 0) {
        return null;
    }
    const delta = current - previous;
    if (Math.abs(delta) < CHART_FLAT_DELTA) {
        return null;
    }
    const label = formatSharePercent((Math.abs(delta) / Math.abs(previous)) * 100);
    if (label == null) {
        return null;
    }
    return { text: `${delta > 0 ? '+' : '-'}${label}`, up: delta > 0 };
};
